import { attr, customElement, FASTElement } from '@microsoft/fast-element';
import { NegotiationTileTemplate as template } from './negotiation-tile.template';
import { NegotiationTileStyles as styles } from './negotiation-tile.styles';
import { IStructuredChatService } from '../../../../services/structured-chat.service';
import { INegotiation } from '../../../../types';
import { StructuredChatModal } from '../structured-chat';
import { ICompanyService } from '../../../../services/company.service';
import { getHtmlIconByName, getTechnologyIconName } from '../../../../styles';
import { getFillColorFromProjectStatus } from '../../../../utils/formatting';

const name = 'negotiation-tile';

@customElement({
  name,
  template,
  styles,
})
export class NegotiationTile extends FASTElement {
  // Service
  @IStructuredChatService structuredChatService: IStructuredChatService;
  @ICompanyService companyService: ICompanyService;

  // Modal config variables
  @attr negotiation: INegotiation = {} as INegotiation;
  @attr context: StructuredChatModal;

  // When negotiation selected from the left hand Engagements(Negotiations) List
  public negotiationSelected() {
    this.structuredChatService.negotiationInView = this.negotiation;
    this.$emit('resetForm', true);
  }

  public getCounterPartyCompany() {
    const currentCompany = this.companyService.getCurrentCompany();
    return currentCompany.CASCADE_COMPANY_ID === this.negotiation.BUYER_COMPANY_ID
      ? this.negotiation.SELLER_COMPANY_NAME
      : this.negotiation.BUYER_COMPANY_NAME;
  }

  public formatStatus() {
    return this.negotiation.NEGOTIATION_STATUS.split('_').join('-').toLowerCase();
  }

  public getTechnologyIcon() {
    return getHtmlIconByName({
      name: getTechnologyIconName(this.negotiation.TECHNOLOGY),
      slot: 'start',
      width: '16px',
      height: '14px',
      fill: getFillColorFromProjectStatus(this.negotiation.PROJECT_OPERATIONAL_STATUS),
    });
  }
}
